(function(){
    'use strict';
    angular.module('app').controller('AdvancedSearchModalController', AdvancedSearchModalController);

    AdvancedSearchModalController.$inject = [
        '$uibModalInstance', 
        'category', 
        'getAreas', 
        'getRoutes', 
        'getDrivers', 
        'TypeStatusConsts'
    ];

    function AdvancedSearchModalController(
        $uibModalInstance, 
        category, 
        getAreas, 
        getRoutes, 
        getDrivers, 
        TypeStatusConsts
    ){
        let vm = this;

        vm.category = category;
        vm.categories = [
            /*'Default',*/
            'Area',
            'Route',
            'Driver',
            'Status'
        ];
        vm.statusLabel = {
            'UNASSIGNED': 'Unassigned',
            'FORAPPROVAL': 'For approval',
            'PENDING': 'Pending',
            'ACCEPTED': 'Accepted',
            'RECEIVED': 'Received',
            'INPROGRESS': 'In progress',
            'FAILED': 'Failed',
            'REJECTED': 'Rejected',
            'DELIVERED': 'Delivered'
        };
        vm.filters = [
            {
                name: 'Status',
                filterBy: 'jobStatus',
                viewFormat: item=>item ? TypeStatusConsts.jobStatuses[item.toLowerCase()] : item,
                Status: {},
                refresh: function(select){
                    this.list = [
                        'UNASSIGNED',
                        'FORAPPROVAL',
                        'PENDING',
                        'ACCEPTED',
                        'RECEIVED',
                        'INPROGRESS',
                        'FAILED',
                        'REJECTED',
                        'DELIVERED'
                    ]
                }
            },
            {
                name: 'Area',
                filterBy: 'area.id',
                viewFormat: (item={}) =>item.areaId,
                refresh: function(select){
                    this.list = [];
                    if(!select.open){
                        return false;
                    }
                    getAreas({areaId: select.search, size: 20}).then(data=>{
                       this.list = data;
                    });
                }
            },
            {
                name: 'Route',
                filterBy: 'route.id',
                viewFormat: (item={}) =>item.code,
                refresh: function(select){
                    this.list = [];
                    if(!select.open){
                        return false;
                    }
                    getRoutes({code: select.search, size: 20}).then(data=>{
                        this.list = data;
                    });
                }
            },
            {
                name: 'Driver',
                filterBy: 'driver.id',
                viewFormat: (item={}) =>`${item.firstName} ${item.lastName}`,
                refresh: function(select){
                    this.list = [];
                    if(!select.open){
                        return false;
                    }
                    getDrivers({firstName: select.search, size: 20}).then(data=>{
                        this.list = data;
                    });
                }
            }
        ];
        vm.close = close;
        vm.search = search;

        function close() {
            $uibModalInstance.dismiss();
        }

        function search(form, performSearch) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }

            angular.extend(vm.category, {
                performSearch: !!performSearch
            });
            
            $uibModalInstance.close(vm.category);
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/jobs/AdvancedSearchModalController.js